export const convertPxToRem = (value: number) => {
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)

  return value / rootFontSize
  // return value / (0.9 * (window.innerWidth / 100))
}
